import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Util } from 'reactstrap'
import Icon from '../Icon/Icon'

const CarouselIndicators = (props) => {
  const { items, activeColor, color, activeIcon, icon, activeIndex, cssModule, onClickHandler, className } = props

  const listClasses = Util.mapToCssModules(classNames(className, 'carousel-indicators'), cssModule)
  const indicators = items && Array.isArray(items) && items.map((item, idx) => {
    const isActive = activeIndex === idx
    const indicatorClasses = Util.mapToCssModules(classNames(
      { active: isActive }
    ), cssModule)

    const _icon = isActive ? activeIcon : icon
    let style = {}
    if (_icon) {
      style.textIndent = 0
      style.color = isActive ? activeColor : color
    } else {
      style.backgroundColor = isActive ? activeColor : color
    }

    return (
      <li
        key={`${item.key || item.src}${item.caption}${item.altText}`}
        onClick={(e) => {
          e.preventDefault()
          onClickHandler(idx)
        }}
        className={indicatorClasses}
        style={{
          ...style,
          ..._icon && { height: 0 }
        }}
      >
        {_icon && <Icon icon={_icon} />}
      </li>)
  })

  return (
    <ol className={listClasses}>
      {indicators}
    </ol>
  )
}

CarouselIndicators.propTypes = {
  items: PropTypes.array.isRequired,
  activeIndex: PropTypes.number.isRequired,
  cssModule: PropTypes.object,
  onClickHandler: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default CarouselIndicators
